module.exports = __webpack_public_path__ + "static/img/EG.5e2f844.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/EG.svg
// module id = vgOi
// module chunks = 66